import { MapperService } from "./mapper-services";
import { Injectable } from "@angular/core";
import { PartnerIdentifiers } from "../interfaces/financial-simulator/financial-product-request.interface";
import { Data } from "../interfaces/data/data.interface";
import { Customer, QuotationRequest, ToBeQuotedVehicle, Vehicle } from "../interfaces/financial-simulator/quotation-interface";

@Injectable({
    providedIn: 'root',
})
export class QuotationMapperService extends MapperService<Data, QuotationRequest>  {

    protected map(entity: Data): QuotationRequest {
        const qt: QuotationRequest = {
            channel: entity.financialData.channel,
            creditTimeUnit: "MONTH",
            currencyCode: entity.financialData.currencyCode,
            customer: this.mapCustomer(entity),
            duration: +entity.financialData.duration || 24,
            financialProductsIds: [entity.financialData.financialProduct.id],
            partnerIdentifiers: this.mapPartnerIdentifiers(entity),
            typeOfUse: "PRIVATE",  // Por defecto
            toBeFinancedGrossAmount : entity.financialData.amountFinanced,//entity.financialData.totalAmount,
            toBeQuotedVehicles: this.mapQuotedVehicle(entity),
            customerCpiProducts: [{
                id : this.mapSecureFinancialProduct(entity), //Quitar, dejar en entity.financialData.secureCode
                quotationId: "",
                name: "",
                description: "",
            }]
        };
        return qt;
    }

    private mapCustomer(entity: Data): Customer {
        // Aquí puedes mapear los identificadores del partner si tienes esa información en Quotations
        // Por ahora, devolvemos un objeto vacío
        // return {
        //     id: 'ID',
        //     person: {
        //         personType :'SELF_EMPLOYED',  //Por defecto
        //         physicalPerson : 'JUAN PEDRO ALEART',   //Vendra de CS/Orders
        //     }
        // };

        return {
            id: 'ID',
            person: {
                personType: 'PHYSICAL',
                physicalPerson: null
            }
        };

        // return {
        //     id: 'ID',
        //     person: {
        //         personType: 'LEGAL',
        //         physicalPerson: null
        //     }
        // };
    }

    private mapQuotedVehicle(entity: Data): ToBeQuotedVehicle[] {
        // Mock de datos de ejemplo para los vehículos
        const quotedVehicle : ToBeQuotedVehicle[] = [
            {
                vehicle: this.mapVehicles(entity),
                totalGrossAmount: entity.financialData.price,
                totalNetAmount: null, //Number((entity.financialData.installmentTotalGrossAmount / 1.21).toFixed(2)), //TODO ASK
                dealerPriceGrossAmount: 0, //TODO Ask?
                dealerDiscountNetAmount: 0, //TODO Ask?
                downPaymentGrossAmount: entity.financialData.downPaymentGrossAmount || 0,
                //downPaymentGrossAmount: this.mapDownPaymentGrossAmount(entity),
                annualMileage: entity.financialData.annualMileages,
                partExchangeCashbackGrossAmount: 0, //TODO Ask?
                objectType: "FinanceableVehicle",
            }
        ];
        return quotedVehicle;
    }

    private mapDownPaymentGrossAmount(entity: Data): number {

        const product = entity.financialData.financialProduct.id;

        if(entity.financialData.financialProducts){

            for(const fp of entity.financialData.financialProducts) {
                if (product === fp.id)
                    return fp.downPaymentGrossAmountRange.maximum / 2;
            }
        }
        return 0;
    }

    private mapSecureFinancialProduct(entity : Data): string {

        if (entity.financialData.financialProducts != null){
            let financialProduct = entity.financialData.financialProducts.filter(product => (product.id == entity.financialData.financialProduct.id));
            return financialProduct[0].cpiProducts[0].id;
        }

        return '';
    }


	private mapPartnerIdentifiers(entity: Data): PartnerIdentifiers {
	    // Aquí puedes mapear los identificadores del partner si tienes esa información en FinancialProducts
	    // Por ahora, devolvemos un objeto vacío
	    return {
	        partnerStoreId: entity.userData.store ? entity.userData.store : '',
	        partnerSalesmanId: entity.userData.salesman ? entity.userData.salesman : '',
	        partnerVendorId: entity.userData.agreement ? entity.userData.agreement : '',
	    };
	}

    private mapVehicles(entity: Data): Vehicle {
        // Mock de datos de ejemplo para los vehículos
        return {
            brand: entity.vehicleData.brand,
            model: entity.vehicleData.model,
            version: entity.vehicleData.version,
            currencyCode: "EUR", //entity.financialData.currencyCode,  //TODO Vehiculo?
            status: "NEW", //TODO Ask?
            firstRegistrationDate: entity.vehicleData.firstRegistrationDate,
            vehicleType: 'CAR', //entity.vehicleData.type,
            currentMileage: entity.vehicleData.mileage,
            energy: "DIESEL", //TODO Ask?
            complementaryEnergy: null, //TODO no se graba/rescata en orders
            vin: entity.vehicleData.vin,
            numberPlate: entity.vehicleData.plateNumber,
            originalPriceGrossAmount: entity.vehicleData.price | 0,
            originalPriceNetAmount: Number((entity.vehicleData.price / 1.21).toFixed(2)),  //TODO Verificar/redondear?
            accessoriesTotalGrossAmount: 0,  //TODO Ask?
            accessoriesTotalNetAmount: 0,
            optionsTotalGrossAmount: 0,
            optionsTotalNetAmount: 0,
            totalPriceGrossAmount: entity.vehicleData.price,
            vehicleIdentifiers: [
                {
                    sourceId: "5",
                    sourceName: entity.userData.agreement ? entity.userData.agreement : 'JLR',
                    vehicleId: entity.vehicleData.version
                }
            ]
        }
    }

    ////// MOCKS //////

    private mapVehiclesMocked(): Vehicle {
        // Mock de datos de ejemplo para los vehículos
        return {
            brand: "JAGUAR",
            model: "F-Type",
            version: "F-Type Coupé 2.0 I4 Aut. 300-2001-3p",
            currencyCode: "EUR",
            status: "NEW",
            firstRegistrationDate: "",
            vehicleType: "CAR",
            currentMileage: 0,
            energy: "DIESEL",
            complementaryEnergy: "NATURAL_GAS",
            vin: "JHMCM826575223941",
            numberPlate: "2036MBF",
            originalPriceGrossAmount: 98500,
            originalPriceNetAmount: 81404.95,
            accessoriesTotalGrossAmount: 0,
            accessoriesTotalNetAmount: 0,
            optionsTotalGrossAmount: 0,
            optionsTotalNetAmount: 0,
            totalPriceGrossAmount: 98500,
            vehicleIdentifiers: [
                {
                    sourceId: "5",
                    sourceName: "JLR5000",
                    vehicleId: "5002176525"
                }
            ]
        }
    }

    private mapPartnerIdentifiersMocked(): PartnerIdentifiers {
        // Mock de datos de ejemplo para los identificadores del partner
        return {
            partnerStoreId: 'JAGUAR',
            partnerSalesmanId: 'R-HOBES',
            partnerVendorId: 'JAGUAR'
        };
    }

    ////// END MOCKS //////
}